import styled from "styled-components";


export const STextArea = styled.textarea`

        margin-top: 1rem;
        width: 100%;
        padding:0.3rem 0 0 0.8rem;
        outline:none;
        font-size: 0.9rem;
        height: 130px;
        transition:all 0.2s ease;
        border: 1px solid ${props => props.theme.colors.border};
        background-color: transparent;
        color: ${props => props.theme.colors.white};
        border-radius: 1rem;

    &.invalid{
        border: 1px solid red ;
    }

    &:first-child{
        margin-right: 1rem;
    }
    

    
` 